import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {PriceMethodType} from "../../types/price-method.type";
import {ContractPriceMethodType} from "../../../contracts/types/contract-price-method.type";

export class ProgramPricingMethodViewCtrl implements IController {

  programId: string;
  programSetting: any;
  accountId: string;
  isShowRoundingType: boolean;


  public programMethodsMap;

  constructor() {
    this.programMethodsMap = _.merge(ContractPriceMethodType, PriceMethodType)
  }

  $onInit() {
  }
}

angular
  .module('bringoz.admin.pricePlan')
  .component('programPricingMethodView', {
    bindings: {
      programId: '<',
      programSetting: '<',
      accountId: '<?',
      isShowRoundingType : '<?'
    },
    template: require('./program-pricing-method-view.html').default,
    controller: ProgramPricingMethodViewCtrl
  });
